import {
  CREATE_PROFILE,
  createProfileSuccess,
  createProfileFailed,
} from "../actions";
import { ofType } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";
import { from, of } from "rxjs";
import GolferApi from "../../../services/golfer-api";

export default (action$) =>
  action$
    .pipe(ofType(CREATE_PROFILE))
    .pipe(switchMap(({ payload }) => action(payload)));

const action = (payload) =>
  from(GolferApi.createProfile(payload))
    .pipe(map((response) => createProfileSuccess(response.data)))
    .pipe(catchError((error) => of(createProfileFailed(error.response?.data))));
